import { Component, OnInit } from '@angular/core';
import {NgForOf, NgIf, NgOptimizedImage} from "@angular/common";
import {LinkCategory} from "./LinkCategory";
import {UsefulLinksService} from "./useful-links.service";

@Component({
  selector: 'app-useful-links',
  imports: [
    NgForOf,
    NgIf,
    NgOptimizedImage
  ],
  templateUrl: './useful-links.component.html',
  styleUrl: './useful-links.component.scss'
})
export class UsefulLinksComponent implements OnInit {
  linkCategories: LinkCategory[] = [];

  constructor(private configService: UsefulLinksService) {}

  ngOnInit(): void {
    this.configService.getLinkCategories().subscribe(categories => {
      this.linkCategories = categories;
    });
  }
}
